import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../../css/sider.scss";

const SiderBar = ({ currentPage, setCurrentPage, isCollapsed }) => {
  const location = useLocation();
  const [expandedMenus, setExpandedMenus] = useState([]);

  const toggleMenu = (menu) => {
    if (expandedMenus.includes(menu)) {
      setExpandedMenus(expandedMenus.filter((m) => m !== menu));
    } else {
      setExpandedMenus([...expandedMenus, menu]);
    }
  };

  const menuItems = [
    {
      id: "home",
      label: "首页",
      icon: "home",
      path: "/userAccount",
      hasSubmenu: false,
    },
    {
      id: "receive",
      label: "全球收款",
      icon: "receive",
      hasSubmenu: true,
      submenus: [
        {
          id: "apply-account",
          label: "申请收款账户",
          path: "/apply-account",
        },
        {
          id: "my-account",
          label: "我的账户",
          path: "/my-account",
        },
        {
          id: "store-management",
          label: "店铺管理",
          path: "/store-management",
        },
        {
          id: "account-holder",
          label: "账户持有人",
          path: "/account-holder",
        },
      ],
    },
    {
      id: "payment",
      label: "全球付款",
      icon: "payment",
      path: "/payment",
      hasSubmenu: false,
    },
    {
      id: "transaction",
      label: "交易管理",
      icon: "transaction",
      hasSubmenu: true,
      submenus: [
        {
          id: "incoming-orders",
          label: "入账订单",
          path: "/incoming-orders",
        },
        {
          id: "payment-orders",
          label: "付款订单",
          path: "/payment-orders",
        },
        {
          id: "turnover-management",
          label: "转账管理",
          path: "/turnover-management",
        },
        {
          id: "fund-planning",
          label: "资金划拨",
          path: "/fund-planning",
        },
        {
          id: "receipt-statement",
          label: "收支明细",
          path: "/receipt-statement",
        },
      ],
    },
    {
      id: "exchange",
      label: "货币兑换",
      icon: "exchange",
      path: "/exchange",
      hasSubmenu: false,
    },
    {
      id: "domestic",
      label: "付款至境内",
      icon: "domestic",
      path: "/domestic",
      hasSubmenu: false,
    },
    {
      id: "ecard",
      label: "E付卡(虚拟卡)",
      icon: "card",
      path: "/ecard",
      hasSubmenu: false,
    },
    {
      id: "settings",
      label: "设置",
      icon: "settings",
      hasSubmenu: true,
      submenus: [
        {
          id: "store-management",
          label: "店铺主体管理",
          path: "/store-entity-management",
        },
        {
          id: "agreement-management",
          label: "协议管理",
          path: "/agreement-management",
        },
        {
          id: "security-settings",
          label: "安全设置",
          path: "/security-settings",
        },
        {
          id: "user-center",
          label: "用户中心",
          path: "/user-center",
        },
        {
          id: "real-name-auth",
          label: "实名认证",
          path: "/real-name-auth",
        },
        {
          id: "account-settings",
          label: "账号设置",
          path: "/account-settings",
        },
        {
          id: "message-subscription",
          label: "消息订阅",
          path: "/message-subscription",
        },
      ],
    },
  ];

  const renderIcon = (iconType, isActive) => {
    const iconMap = {
      home: { normal: "/sider/s1-1.png", active: "/sider/s1-2.png" },
      receive: { normal: "/sider/s2-1.png", active: "/sider/s2-2.png" },
      payment: { normal: "/sider/s3-1.png", active: "/sider/s3-2.png" },
      transaction: { normal: "/sider/s4-1.png", active: "/sider/s4-2.png" },
      exchange: { normal: "/sider/s5-1.png", active: "/sider/s5-2.png" },
      domestic: { normal: "/sider/s6-1.png", active: "/sider/s6-2.png" },
      card: { normal: "/sider/s7-1.png", active: "/sider/s7-2.png" },
      settings: { normal: "/sider/s8-1.png", active: "/sider/s8-2.png" },
    };

    const iconSrc = isActive
      ? iconMap[iconType]?.active
      : iconMap[iconType]?.normal;

    return <img src={iconSrc} alt={iconType} className="menu-icon-img" />;
  };

  // 检查当前路径是否匹配菜单项
  const isMenuActive = (item) => {
    if (item.path) {
      return location.pathname === item.path;
    }
    if (item.submenus) {
      return item.submenus.some((sub) => location.pathname === sub.path);
    }
    return false;
  };

  // 当路由变化时，自动展开包含当前路由的菜单
  useEffect(() => {
    const menusToExpand = [];
    menuItems.forEach((item) => {
      if (item.hasSubmenu && item.submenus) {
        const hasActiveSubmenu = item.submenus.some(
          (sub) => location.pathname === sub.path
        );
        if (hasActiveSubmenu) {
          menusToExpand.push(item.id);
        }
      }
    });

    if (menusToExpand.length > 0) {
      setExpandedMenus((prev) => {
        const newExpanded = [...prev];
        menusToExpand.forEach((menuId) => {
          if (!newExpanded.includes(menuId)) {
            newExpanded.push(menuId);
          }
        });
        return newExpanded;
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <aside className={`sidebar-container ${isCollapsed ? "collapsed" : ""}`}>
      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          <div key={item.id} className="menu-item-wrapper">
            {item.hasSubmenu ? (
              // 有子菜单的项目
              <div
                className={`menu-item ${isMenuActive(item) ? "active" : ""}`}
                onClick={() => toggleMenu(item.id)}
                title={isCollapsed ? item.label : ""}
              >
                <div className="menu-item-content">
                  <div className="menu-icon">
                    {renderIcon(item.icon, isMenuActive(item))}
                  </div>
                  <span className="menu-label">{item.label}</span>
                </div>
                <svg
                  className={`menu-arrow ${
                    expandedMenus.includes(item.id) ? "expanded" : ""
                  }`}
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="currentColor"
                >
                  <path
                    d="M4 6l4 4 4-4"
                    stroke="currentColor"
                    strokeWidth="2"
                    fill="none"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
            ) : (
              // 没有子菜单的项目，使用 Link
              <Link
                to={item.path}
                className={`menu-item ${isMenuActive(item) ? "active" : ""}`}
                title={isCollapsed ? item.label : ""}
              >
                <div className="menu-item-content">
                  <div className="menu-icon">
                    {renderIcon(item.icon, isMenuActive(item))}
                  </div>
                  <span className="menu-label">{item.label}</span>
                </div>
              </Link>
            )}
            {item.hasSubmenu &&
              expandedMenus.includes(item.id) &&
              item.submenus && (
                <div className="submenu-container">
                  {item.submenus.map((submenu) => (
                    <Link
                      key={submenu.id}
                      to={submenu.path}
                      className={`submenu-item ${
                        location.pathname === submenu.path ? "active" : ""
                      }`}
                    >
                      {submenu.label}
                    </Link>
                  ))}
                </div>
              )}
          </div>
        ))}
      </nav>
    </aside>
  );
};

export default SiderBar;
